import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { ChevronDown, Menu, X } from "lucide-react";
import { navLinks } from "../mock";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [communityOpen, setCommunityOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `px-4 py-2 text-sm tracking-[0.15em] font-semibold transition-colors ${
      isActive ? "text-[#e8a13a]" : "text-[#f5f1e8] hover:text-[#e8a13a]"
    }`;

  return (
    <header className="sticky top-0 z-40 bg-[#181818]/95 backdrop-blur border-b border-[#2a2a2a]">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="font-display text-xl tracking-wider text-[#e8a13a]">
          BRAINS ON TAP
        </Link>

        {/* Desktop */}
        <nav className="hidden lg:flex items-center gap-2">
          {navLinks.map((item) => {
            if (item.children) {
              return (
                <div
                  key={item.label}
                  className="relative"
                  onMouseEnter={() => setCommunityOpen(true)}
                  onMouseLeave={() => setCommunityOpen(false)}
                >
                  <button className="px-4 py-2 text-sm tracking-[0.15em] font-semibold text-[#f5f1e8] hover:text-[#e8a13a] flex items-center gap-1">
                    {item.label.toUpperCase()}
                    <ChevronDown className="w-3 h-3" />
                  </button>
                  {communityOpen && (
                    <div className="absolute top-full left-0 min-w-[240px] bg-[#181818] border border-[#2a2a2a] shadow-xl py-2 z-50">
                      {item.children.map((c) => (
                        <NavLink
                          key={c.to}
                          to={c.to}
                          className="block px-5 py-3 text-sm tracking-wider text-[#f5f1e8] hover:text-[#e8a13a] hover:bg-[#232323]"
                        >
                          {c.label}
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            return (
              <NavLink key={item.to} to={item.to} className={linkClass}>
                {item.label.toUpperCase()}
              </NavLink>
            );
          })}
        </nav>

        {/* Mobile toggle */}
        <button
          className="lg:hidden text-[#f5f1e8]"
          onClick={() => setOpen(!open)}
          aria-label="menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#181818] border-t border-[#2a2a2a] px-6 py-4 space-y-2">
          {navLinks.map((item) => {
            if (item.children) {
              return (
                <div key={item.label} className="py-1">
                  <div className="text-[#e8a13a] text-xs tracking-widest font-semibold py-2">
                    {item.label.toUpperCase()}
                  </div>
                  {item.children.map((c) => (
                    <NavLink
                      key={c.to}
                      to={c.to}
                      onClick={() => setOpen(false)}
                      className="block pl-4 py-2 text-sm text-[#f5f1e8] hover:text-[#e8a13a]"
                    >
                      {c.label}
                    </NavLink>
                  ))}
                </div>
              );
            }
            return (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className="block py-2 text-sm tracking-widest font-semibold text-[#f5f1e8] hover:text-[#e8a13a]"
              >
                {item.label.toUpperCase()}
              </NavLink>
            );
          })}
        </div>
      )}
    </header>
  );
};

export default Navbar;
